<template>
  <Layout @currentPage="currentPage" :hasPagination="false" :hasBreadcrumbs="true" :amount="16" :openModalHandler="openModalHandler">
    <div class="content">
      <div class="page-content">
        <MainTitle :title="this.$router.currentRoute.name"  />
        <UserTable @selectedRow="gotUser" :users="this.users" />
      </div>
      <div class="sidebar">
        <TableAction :hasButton="this.userDetails.isAdmin == 1 ? true : false" @clickedButton="gotClick" title="Add new user" :isAdd="true"/>
        <TableDetail v-if="this.selectedUser" :details="this.selectedUser" @refresh="gotRefresh" />
      </div>
    </div>
  </Layout>
</template>
<script>
// @ is an alias to /src
import Layout from "@/layouts/Dashboard";
import UserTable from "@/components/TblUsers";
import TableAction from "@/components/TableAction";
import TableDetail from "@/components/TblUsersDetail";
import MainTitle from "@/components/base/MainTitle";

export default {
  name: "management-rawmaterials",
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  props: {
  },
  data () {
    return {
      users: null,
      amount: null,
      selectedUser: null,
      pagina: 1,
      openModalHandler: false,
    }
  },
  components: {
    Layout,
    UserTable, 
    MainTitle, 
    TableAction,
    TableDetail,
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      var that = this
      this.$http.get(this.$endpoint + 'management/users/all')
      .then(response => {
        that.users = response.data
        that.selectedUser = null
      })
      .catch(error => {
        if (error.response.status === 401) {
          this.$store
          .dispatch("logout")
          .then(() => this.$router.push("/login"))
          .catch(err => console.log(err));
        } else {
          that.$swal(
            'Oops that went wrong?',
            `Please contact the admin with the following info: ${ error }`,
            'error'
          );
        }
      })
    },
    currentPage(page) {
      this.pagina = page // someValue
    },
    gotUser(user) {
      this.selectedUser = user // someValue
    },
    gotClick(val) {
      this.openModalHandler = !this.openModalHandler;
    },
    gotRefresh(val) {
      this.getData()
    }
  },
  watch: {
    pagina: function (val) {
      this.getData()
    } 
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";
/* 
.sidebar {
  background-color: red;
} */
</style>;
